import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clearInProgressItems, getItemById, isDiscountedPriceAvailableForSellableItem, isDiscountItemPrice, isNormalItem as isNormalItemUtil } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { ItemDetails } from '../item-details/item-details';
import { ItemImage } from '../item-image/item-image';
import { Modal } from '../modal';
import { ItemModalFooter } from './subcomponents/footer';
import { ItemModalQuantityInput } from './subcomponents/quantity-input';
const b = bemClassBuilder('v-item-modal');
export const ItemModal = observer(props => {
    const { sellableItem, show, className, onClose, children, displayText, assets, getDisplayPrice, imageCdnOptions, promotionLabel, itemPrice } = props;
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Failed to render ItemModal. Could not find item with ID: ${sellableItem.itemId}.`);
    const isNormalItem = isNormalItemUtil(item);
    const hasDiscount = itemPrice
        ? isDiscountItemPrice(itemPrice)
        : isDiscountedPriceAvailableForSellableItem(sellableItem);
    const handleModalClosed = useCallback(() => {
        onClose();
        if (!props.readonly)
            clearInProgressItems();
    }, [props.readonly, onClose]);
    return (_jsxs(Modal, Object.assign({ className: b.block(undefined, className), closeButtonIconName: assets.closeModalButtonIconName, show: show, onClose: handleModalClosed, footer: !props.readonly && (_jsx(ItemModalFooter, { displayText: displayText, assets: assets, isNormalItem: isNormalItem, onAddToCart: props.onAddToCart, quantityInputProps: getQuantityInputProps(props) })) }, { children: [_jsx(ItemImage, { item: item, className: b.element('backdrop-image'), cdnOptions: imageCdnOptions, promotedLabel: promotionLabel }), _jsx(ItemDetails, { item: item, showDescription: true, showPrice: isNormalItem, className: b.element('item-details'), getDisplayPrice: getDisplayPrice, priceFormat: { showDefaultPrice: false, applyDiscountedFormat: hasDiscount } }), children, !props.readonly && isNormalItem && (_jsx(ItemModalQuantityInput, Object.assign({}, getQuantityInputProps(props), { className: b.element('base-quantity-picker') })))] })));
});
ItemModal.displayName = 'ItemModal';
const getQuantityInputProps = (props) => {
    const { config, sellableItem, itemPrice, allowedMaximumForPriceRestrictedItem, isEditViewActive } = props;
    const { quantityLimit, quantityInputType } = config;
    return {
        quantityInputType,
        sellableItem,
        itemPrice,
        min: quantityLimit.minimum,
        max: !quantityLimit.isUnlimited ? quantityLimit.maximum : undefined,
        allowedMaximumForPriceRestrictedItem,
        isEditViewActive
    };
};
